import * as React from "react";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { StoreContext } from '../../store/StoreProvider';
import { Typography } from "@material-ui/core";
import { merchListExt, merchListHistoryExt, clientPointsGetExt } from "../../store/sagas/Clients";

interface WelcomeModalProps {
    open?: boolean;
    imgstatic?: boolean;
    image?: string;
    onClose?: () => void;
}
export const WelcomeModal = (props: WelcomeModalProps) => {
    const [store, dispatch] = React.useContext(StoreContext);
    const [open, setOpen] = React.useState(props.open ?? false);
    const [poinstClient, setPointsClient] = React.useState<number>(0);

    const clientId: string = store?.user?.user_login;
    const cardCodeParent: string = store?.user?.cardCode2 ?? store?.user.id;
    console.log(clientId)

    React.useEffect(() => {
        // obtener puntos del cliente
        clientPointsGetExt({ "cardCode": clientId, "cardCodePadre": cardCodeParent, }).then((response) => {
            if (response.status === "ok") {
                setPointsClient(response.data);
            }
        })
    }, [clientId, store?.user.tipo, cardCodeParent]);

    return (
        <div style={{}}>
            <Dialog fullWidth={true} maxWidth={'xs'} open={open} onClose={() => console.log('')} className={"modal-banner-custom"}>

                <DialogContent>
                    <IconButton
                        aria-label="close"
                        size="small"
                        onClick={() => {
                            if (!!props?.onClose) {
                                props.onClose();
                            }

                            setOpen(false);
                        }}
                        sx={{
                            position: 'absolute',
                            right: 9, top: 8,
                            background: "#FFFFFF!important",
                            color: "#000"
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Typography style={{ fontWeight: 'bold', marginBottom: 10 }} variant="h6" component="div" gutterBottom>
                        🎁 ¡Hola, estimado Socio!
                    </Typography>
                    
                    <Typography>
                        
                        Tienes <strong>{poinstClient}</strong> puntos <strong>GARDI</strong> acumulados.
                        ¡Canjéa desde audífonos 🎧 hasta una Moto! o Aprovecha nuestra campaña navideña y canjea vales de pavo, caja de 6 panetones o una canasta navideña! 🎄✨
                    </Typography>
                </DialogContent>
            </Dialog>
        </div>
    );
};
